export const splitTextFromSecretSymbol = (str) => {
  return str?.split?.('|n|').join('\n') ?? '';
};
